import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getAllFolder, deleteFolder } from "../api/folderapi";
import { getFileIcon } from "../utils/Icon";
import { FileContext } from "../context/FileContext";
import FileView from "../Component/FIleView";
import DeleteView from "../Component/DeleteView";
import { FaLock } from "react-icons/fa";
import { CiMenuKebab, CiSettings, CiSearch } from "react-icons/ci";
import { BsDownload } from "react-icons/bs";
import { AiOutlineDelete } from "react-icons/ai";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "react-toastify";
import FileContainer from "../Component/FileContainer";

const Filelist = () => {
  const {
    files,
    setFiles,
    viewType,
    setViewType,
    search,
    setSearch,
    sortOption,
  } = useContext(FileContext);

  const [videos, setVideos] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(null);
  const menuRef = useRef(null);
  const [selectedFolderForDelete, setSelectedFolderForDelete] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

 useEffect(() => {
  setIsLoading(true);
  getAllFolder()
    .then((res) => {
      const videoFiles = res.data
        .filter(
          (item) =>
            item.mimeType &&
            item.mimeType.toLowerCase().includes("application")
        )
        .map((item) => ({
          ...item,
          sizeMB: item.size ? (Number(item.size) / (1024 * 1024)).toFixed(2) : null,
        }));
      setVideos(videoFiles);
    })
    .catch((err) => console.log("Error fetching videos:", err))
    .finally(() => setIsLoading(false));
}, []);


  const handleItemClick = (item) => {
    if (item.type === "folder") {
      navigate("/folder/" + item._id);
    } else {
      setSelectedFile(item);
    }
  };

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openFolderSettings = (folder) => {
    setSelectedFile(folder);
  };

  const handleDeleteClick = (folder) => {
    setSelectedFolderForDelete(folder);
    setIsPopupOpen(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      if (selectedFolderForDelete) {
        await deleteFolder(selectedFolderForDelete._id);
        const updatedVideos = videos.filter(
          (video) => video._id !== selectedFolderForDelete._id
        );
        setVideos(updatedVideos);
        const updatedFiles = files.filter(
          (file) => file._id !== selectedFolderForDelete._id
        );
        setFiles(updatedFiles);
        setIsPopupOpen(false);
        setSelectedFolderForDelete(null);
        setMenuOpen(null);
        toast.success("File deleted successfully");
      }
    } catch (error) {
      toast.error("Error deleting file");
    }
  };

  const handleDeleteCancel = () => {
    setIsPopupOpen(false);
    setSelectedFolderForDelete(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="  mt-[10%] md:mt-[4%]">
      <div className="flex">
    
      </div>

      <h2 className="text-xl font-semibold text-gray-800 ">Files</h2>

    {isLoading ? (
  <div className="flex justify-center items-center min-h-[60vh] min-w-[700px]">
    <div className="w-12 h-12 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
  </div>
) : (
  <div className="grid grid-cols-2 gap-5 mt-5 md:grid-cols-4 lg:grid-cols-5">
    {videos
      .filter((file) =>
        !search || file.name?.toLowerCase().includes(search.toLowerCase())
      )
      .map((file, index) => {
        const icon = getFileIcon(file.name, file.url);
        return (
          <FileContainer
            key={index}
            className="relative flex flex-col items-center border border-gray-300 rounded-md shadow w-48 h-28"
          >
            <div className="relative w-full">
              {/* Menu Icon */}
              <span className="absolute right-0 p-2">
                <CiMenuKebab
                  onClick={() => setMenuOpen(menuOpen === index ? null : index)}
                />
              </span>

              {/* Dropdown Menu */}
              <AnimatePresence>
                {menuOpen === index && (
                  <div
                    className="absolute right-0 z-50 bg-white border border-gray-200 rounded-md shadow-lg top-6 w-48 h-28"
                    ref={menuRef}
                  >
                    <ul className="flex flex-col p-2">
                      {file.type !== "folder" && (
                        <li>
                          <button
                            onClick={() => handleDownload(file.url)}
                            className="flex items-center w-full gap-2 px-3 py-2 text-gray-700 rounded-md hover:bg-gray-100"
                          >
                            <BsDownload className="w-4 h-4 text-blue-500" />
                            <span className="text-sm font-medium">Download</span>
                          </button>
                        </li>
                      )}
                      <li>
                        <button
                          onClick={() => openFolderSettings(file)}
                          className="flex items-center w-full gap-2 px-3 py-2 text-gray-700 rounded-md hover:bg-gray-100"
                        >
                          <CiSettings className="w-4 h-4 text-gray-500" />
                          <span className="text-sm font-medium">Settings</span>
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => handleDeleteClick(file)}
                          className="flex items-center w-full gap-2 px-3 py-2 text-red-600 rounded-md hover:bg-red-100"
                        >
                          <AiOutlineDelete className="w-4 h-4 text-red-500" />
                          <span className="text-sm font-medium">Delete</span>
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </AnimatePresence>

              {/* File Preview */}
              <div className="relative mt-5 flex items-center justify-center overflow-hidden h-32 bg-gray-50 rounded-lg cursor-pointer">
                {file.isLocked && (
                  <FaLock
                    className="absolute top-1 left-1 text-red-500 z-10"
                    fontSize={14}
                  />
                )}
                <div
                  onClick={() => handleItemClick(file)}
                  className="flex items-center justify-center w-full h-full"
                >
                  {typeof icon === "string" ? (
                    <img
                      src={icon}
                      alt={file.name}
                      className="max-w-full max-h-full object-contain"
                    />
                  ) : (
                    icon
                  )}
                </div>
              </div>
            </div>

            {/* File Name */}
            <div className="px-3 py-3 text-center">
              <p className="text-sm font-medium text-gray-800 truncate">
                {file.name.length > 10 ? file.name.slice(0, 10) + "..." : file.name}
              </p>
            </div>
          </FileContainer>
        );
      })}
  </div>
)}


      {selectedFile && (
        <FileView
          selectedFile={selectedFile}
          setSelectedFile={setSelectedFile}
          handleDownload={handleDownload}
        />
      )}

      {isPopupOpen && (
        <DeleteView
          handleDeleteCancel={handleDeleteCancel}
          handleDeleteConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
};

export default Filelist;
